import { Component, inject } from '@angular/core';

import { of } from 'rxjs';

import { DocumentsGridComponent, UploadDocumentModal } from '@camelot/core';
import { CamGridDataService } from '@camelot/core';
import { ErrorBoxModal } from '@camelot/notification';
import { CamEnumerationService } from '@camelot/services';
import { DepartmentsComponent } from '@camelot/ui';

import { TestIdDirective } from '@camelot/testing-harness';

interface DepartmentLike {
  iconPath: string | null;
  id: number;
  name: string | null;
}

const enumerationServiceMock = {
  fetchFileTypes: () => of([]),
};

@Component({
    imports: [DepartmentsComponent, DocumentsGridComponent, ErrorBoxModal, TestIdDirective, UploadDocumentModal],
    providers: [{ provide: CamEnumerationService, useValue: enumerationServiceMock }],
    template: `
    <cam-departments camTestId="cam-departments" [departments]="this.departments" [professions]="this.professions" />
    <cam-documents-grid camTestId="cam-documents-grid" [gridId]="this.gridId" [documents$]="this.documents$" />
    <cam-upload-document-content camTestId="cam-upload-document-content" />
    <cam-notification-error-box camTestId="cam-notification-error-box" />
  `
})
export class CoreModalsCase {
  public departments: DepartmentLike[] = [{ iconPath: null, id: 1, name: 'Department one' }];
  public documents$ = of([]);
  public gridId = 'e2e-documents-grid';
  public professions = ['Plumber'];

  private readonly _dataService = inject(CamGridDataService);

  ngOnInit(): void {
    this._dataService.get(this.gridId, true).switchView('grid');
  }
}
